import { render, staticRenderFns } from "./ChangeToBusinessForm.vue?vue&type=template&id=480be7a0&scoped=true"
import script from "./ChangeToBusinessForm.vue?vue&type=script&lang=js"
export * from "./ChangeToBusinessForm.vue?vue&type=script&lang=js"
import style0 from "./ChangeToBusinessForm.vue?vue&type=style&index=0&id=480be7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480be7a0",
  null
  
)

export default component.exports